export default (node) => {
  const buttons = node.querySelectorAll('[data-filter-btn]');
  const blocks = node.querySelectorAll('[data-collection-block]');

  const init = () => {
    if (!buttons.length || !blocks.length) return;

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.filter.toLowerCase().trim();

        buttons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');

        blocks.forEach((block) => {
          const tags =
            block.dataset.tags
              ?.toLowerCase()
              .split(',')
              .map((tag) => tag.trim()) || [];

          if (filter === 'all' || tags.includes(filter)) {
            block.classList.remove('hidden');
          } else {
            block.classList.add('hidden');
          }
        });
      });
    });
  };

  init();
};
